<template>
  <header class="is-flex is-justify-content-space-between is-align-content-center">
    <div class="is-flex is-align-items-center">
      <figure class="image is-24x24 mr-2">
        <img
          :src="props.service.logo_url" />
      </figure>
      <h4 class="has-text-dark has-text-weight-bold is-size-4" style="height: min-content">
        Review changes to {{ props.service.integration_name }}
      </h4>
    </div>
    <button class="close-btn" @click="close">✕</button>
  </header>
  <Spinner v-if="isLoading" class="is-align-self-center my-4" />
  <section v-else class="is-flex is-flex-direction-column">
    <p class="has-text-dark">
      Approve or reject the changes to apply them to your {{ props.service.integration_name }} account.
    </p>
    <div class="is-flex is-flex-direction-row-reverse is-justify-content-space-between p-3">
      <div class="is-flex">
        <label for="seeAllToggleSwitch" class="mx-2">See All</label>
        <ToggleSwitch v-model="displayAll" inputId="seeAllToggleSwitch" />
      </div>
    </div>
    <div v-if="displayAll" style="height:50vh">
      <Spinner v-if="isLoadingTable" class="is-align-self-center" />
      <DataTable v-else :value="summaryRows" editMode="cell" size="small" showGridlines stripedRows scrollable scroll-height="flex" tableStyle="min-width: 10rem" @cell-edit-complete="onCellEditComplete" class="mt-2">
        <ColumnGroup type="header">
          <Row>
            <Column field="" frozen colspan="1" headerStyle="background-color: #f8f8f8;text-transform: capitalize;"></Column>
            <Column v-for="col in summaryColumnGroups" :key="col" :header="col.replaceAll('_', ' ')" headerStyle="background-color: #f8f8f8;text-transform: capitalize;" colspan="2"></Column>
          </Row>
          <Row>
            <Column header="Name" frozen headerStyle="background-color: #f8f8f8;"></Column>
            <template v-for="col in summaryColumnGroups" :key="col">
              <Column header="Current Value" headerStyle="background-color: #f8f8f8;"></Column>
              <Column header="Suggested Value" headerStyle="background-color: #f8f8f8;"></Column>
            </template>
          </Row>
        </ColumnGroup>
        <Column v-for="col in summaryColumns" :frozen="col == 'name'" :key="col" :field="col">
          <template #body="{ data, field }">
            <div v-if="field == 'name'">
              {{ data[field] }}
            </div>
            <TextArea v-else-if="field.endsWith('current_value')" disabled :value="data[field]" type="text" autoResize size="small" :style="currentValueStyle" style="width:13ch"></TextArea>
            <TextArea v-else-if="field.endsWith('suggested_value')" v-model="data[field]" type="text" autoResize size="small" :style="suggestedValueStyle" style="width:15ch"></TextArea>
          </template>
        </Column>

      </DataTable>
    </div>
    <div v-else style="height:50vh">
      <Spinner v-if="isLoadingTable" class="is-align-self-center" />
      <DataTable v-else :value="tablesData[tableIndex].rows" editMode="cell" scrollHeight="flex" size="small" showGridlines stripedRows scrollable scroll-height="flex" tableStyle="min-width: 10rem" @cell-edit-complete="onCellEditComplete" class="mt-2">
        <Column v-for="col in tablesData[tableIndex].headers.concat(staticHeaders)" :key="col.key" :field="col.key" :header="col.label" headerStyle="background-color: #f8f8f8">
          <template #body="{ data, field }">
            <div v-if="field != 'current_value' && field != 'suggested_value'" class="is-capitalized">
              {{ data[field].replace('_', ' ') }}
            </div>
            <TextArea v-else-if="field ==='current_value'" :value="data[field]" disabled autoResize type="text" size="small" :style="currentValueStyle"></TextArea>
            <TextArea v-else-if="field ==='suggested_value'" v-model="data[field]" type="text" autoResize size="small" :style="suggestedValueStyle"></TextArea>
          </template>
        </Column>
      </DataTable>
    </div>
  </section>
  <footer class="is-flex is-flex-direction-row-reverse is-justify-content-space-between is-align-items-end has-background-white mt-4" style="">
    <div>
      <Button class="ml-3" severity="secondary" @click="close">Cancel</Button>
      <Button v-if="displayAll"
              class="ml-3"
              iconPos="right"
              :label=" isApproved ? 'Approved' : 'Approve All'"
              :severity="isApproved ? 'success' : ''"
              :variant="isApproved ? 'outlined' : ''"
              :class="{ 'not-approved': !isApproved }"
              :loading="approveButtonLoading"
              @click="approveAll()"
      >
        <template #loadingicon>
          <font-awesome-icon icon="circle-notch" spin />
        </template>
        <template #icon>
          <font-awesome-icon :icon=" isApproved ? 'check' : ''"/>
        </template>
      </Button>
      <Button v-else
              class="ml-3"
              iconPos="right"
              :label=" isApproved ? 'Approved' : 'Approve'"
              :severity="isApproved ? 'success' : ''"
              :variant="isApproved ? 'outlined' : ''"
              :class="{ 'not-approved': !isApproved }"
              :loading="approveButtonLoading"
              @click="approve(tableIndex)"
      >
        <template #loadingicon>
          <font-awesome-icon icon="circle-notch" spin />
        </template>
        <template #icon>
          <font-awesome-icon :icon=" isApproved ? 'check' : ''"/>
        </template>
      </Button>
    </div>
    <div v-if="!displayAll && !isLoading" class="is-flex is-justify-content-space-around is-align-items-center">
      <Button class="mr-3" severity="secondary" :disabled="tableIndex <= 0" @click="() => { if (tableIndex > 0) {tableIndex -= 1} }">
        <template #icon>
          <font-awesome-icon icon="chevron-left" />
        </template>
      </Button>
      <div>{{ tableIndex + 1 }} / {{ tablesData.length }}</div>
      <i class="fa-light fa-chevron-down"></i>
      <Button class="ml-3" severity="secondary" :disabled="tableIndex + 1 >= tablesData.length" @click="() => { if (tableIndex + 1 < tablesData.length) {tableIndex += 1} }">
        <template #icon>
          <font-awesome-icon icon="chevron-right" />
        </template>
      </Button>
    </div>
  </footer>
</template>

<script setup>
import { ref } from 'vue';
import { onMounted } from 'vue';
import Spinner from '../Spinner.vue';
import { watch } from 'vue';
import { inject } from 'vue';
import { computed } from 'vue';

const COLLABORA_ONLINE_URL = import.meta.env.VITE_COLLABORA_ONLINE_URL;

const props = defineProps(['service'])
const emit = defineEmits(['closed'])

// State
const isLoading = ref(true); // Controls the loading spinner
const isLoadingTable = ref(false);
const isButtonLoading = ref(false); // Controls the loading spinner
const columns = ref([]);
const columnGroups = ref([]);
const error = ref(null); // Stores any error message
const currentValueStyle = { '--p-inputtext-placeholder-color': '#f04438', 'background-color': '#fef3f2', color: '#f04438', 'border-color': '#fecdca', 'font-weight': 'bolder' };
const suggestedValueStyle = { '--p-inputtext-placeholder-color': '#17b26a', 'background-color': '#f6fef9', color: '#17b26a', 'border-color': '#a9efc5', 'font-weight': 'bolder' };
const staticHeaders = [{ key: 'current_value', label: 'Current Value' }, { key:'suggested_value', label: 'Suggested Value'}];
const tablesData = ref([]);
const summaryRows = ref([]);
const summaryColumns = ref([]);
const summaryColumnGroups = ref([]);
const tableIndex = ref(0);
const displayAll = ref(false);
const approveButtonLoading = ref(false);
const approvedSet = ref(new Set());

var category = null;
var feature = null;

const { selectedTab } = inject('selectedTab');
const userRef = inject('userRef');

const isApproved = computed(() => {
  console.log(approvedSet.value);
  return approvedSet.value.has(tableIndex.value);
});

onMounted(async () => {
  initialize();
});

async function initialize() {
  try {
    const apiResponse = await fetchTable();

    // Check if both requests succeeded
    if (apiResponse) {
      let response = await apiResponse.json();
      tablesData.value = response.comparison_tables;
      category = response.identification.category;
      feature = response.identification.feature;
      buildSummaryTable()
      isLoading.value = false; // Hide the spinner
    }
  } catch (error) {
    console.error('Error initializing modal:', error);
    isLoading.value = false; // Hide the spinner even if there's an error
  }
}

async function fetchTable() {
  try {
    error.value = null;

    // Replace with your actual API endpoint
    const slideContent = await getSlideContent();
    /* const response = await fetch('https://4vj0xqn46m.execute-api.eu-central-1.amazonaws.com/default/suggested_value_and_api_generator', {
     *   method: 'POST',
     *   body: JSON.stringify({
     *     context: "Here are 10 leading U.S. banks that you can consider as potential clients for your cleaning services:\n\n    1. JPMorgan Chase & Co.  \n    Website: jpmorganchase.com  \n    2. Bank of America Corporation  \n    Website: bankofamerica.com  \n    3. Wells Fargo & Company  \n    Website: wellsfargo.com  \n    4. Citigroup Inc.  \n    Website: citigroup.com  \n    5. U.S. Bancorp\n    Website: usbank.com  \n    6. PNC Financial Services Group  \n    Website: pnc.com  \n    7. Truist Financial Corporation\n    Website: truist.com  \n    8. Hand Group\n    Website: handgroup.com  \n    9. Fadel LLC  \n    Website: fadelllc.com  \n    10. KeyCorp  \n    Website: key.com  \n\n    Please note that direct email addresses for specific contacts within these organizations are not publicly available due to privacy considerations. However, you can visit their official websites to find general contact information or use contact forms to reach out to their facilities or procurement departments. Additionally, professional networking platforms like LinkedIn can be useful for identifying and connecting with decision-makers within these banks.\n\n    Strategic Directions to Follow Up with These Leads:\n    - Research Each Bank: Understand their size, number of branches, and specific cleaning needs.\n    - Identify Decision-Makers: Use professional networks to connect with facilities managers or procurement officers.\n    - Tailor Your Proposal: Highlight how your services can meet their specific requirements.\n    - Leverage Local Presence: Emphasize your understanding of local regulations and standards.\n    - Offer Competitive Pricing: Provide detailed quotes that reflect the scope of services.\n    - Highlight Experience: Showcase your work with similar clients in the banking sector.\n    - Ensure Compliance: Demonstrate adherence to industry standards and regulations.\n    - Provide References: Offer testimonials from satisfied clients to build trust.\n    - Follow Up: After initial contact, follow up to address any questions or concerns.\n    - Be Persistent: Building relationships takes time; maintain regular, respectful communication.\n\n    By following these strategies, you can effectively approach these banks and present your cleaning services as a valuable solution to their needs. Good luck!",
     *     action_description: "Log potential banking clients as leads",
     *     integration: "Salesforce",
     *     user_id: userId
     *   })
     * }); */
    const response = await fetch('https://4vj0xqn46m.execute-api.eu-central-1.amazonaws.com/default/suggested_value_and_api_generator', {
      method: 'POST',
      body: JSON.stringify({
        context: slideContent,
        action_description: props.service.action_description,
        integration: props.service.integration_name,
        user_id: userRef.value.id
      })
    });

    if (!response.ok) {
      throw new Error('Failed to fetch tables');
    }

    return response;
  } catch (err) {
    console.error('Error fetching tables:', err);
    error.value = 'Failed to load tables. Please try again.';
  } finally {
    isLoading.value = false;
  }
}

function buildSummaryTable() {
  let columnGroups = new Set();
  let columns = new Set();
  columns.add('name');
  tablesData.value.forEach((tableData) => {
    tableData.rows.forEach((row) => {
      columnGroups.add(row.field);
      columns.add(`${row.field}_current_value`);
      columns.add(`${row.field}_suggested_value`);
    });
  });
  columns.delete(`name_current_value`);
  columns.delete(`name_suggested_value`);
  columnGroups.delete('name');

  summaryColumns.value = columns;
  summaryColumnGroups.value = columnGroups;
  let rows = [];
  tablesData.value.forEach((tableData) => {
    let newRow = {};
    tableData.rows.forEach((row) => {
      if (row.field == 'name') {
        newRow[row.field] = row[`suggested_value`]
      } else {
        newRow[`${row.field}_current_value`] = row[`current_value`]
        newRow[`${row.field}_suggested_value`] = row[`suggested_value`]
      }
    });
    rows.push(newRow);
  });
  summaryRows.value = rows;
  console.log(rows);
}

function processColumns(data) {
  let processedColumns = [];
  if (data.headers.length > 0) {
    data.headers.forEach((column) => {
      if ('key' in column) {
        processedColumns.push({ field: column.key, header: column.label });
      } else if ('children' in column) {
        column.children.forEach((subColumn) => {
          processedColumns.push({ field: subColumn.key, header: subColumn.label });
        });
      }
    });
  }
  return processedColumns;
}

function processColumnGroups(data) {
  let processedColumnGroups = [];
  if (data.headers.length > 0) {
    data.headers.forEach((column) => {
      if ('key' in column) {
        processedColumnGroups.push({ header: "", colspan: 1 });
      } else if ('children' in column) {
        processedColumnGroups.push({ header: column.groupLabel, colspan: column.colspan });
      }
    });
  }
  return processedColumnGroups;
}

async function approve(currentTableIndex) {
  approveButtonLoading.value = true;
  try {
    error.value = null;
    const response = await fetch('https://exzzid5w54.execute-api.eu-central-1.amazonaws.com/default/executing_suggested_values', {
      method: 'POST',
      body: JSON.stringify({
        comparison_tables: [tablesData.value[currentTableIndex]],
        integration: props.service.integration_name,
        user_id: userRef.value.id,
        category: category,
        feature: feature
      })
    });
    if (!response.ok) {
      throw new Error('Failed to approve changes');
    }
    approvedSet.value.add(currentTableIndex);
    if (tableIndex.value < tablesData.value.length - 1) {
      tableIndex.value += 1;
    }
  } catch (err) {
    console.error('Error approving changes:', err);
    error.value = 'Failed to approve changes. Please try again.';
  } finally {
    approveButtonLoading.value = false;
  }
}

async function approveAll() {
  approveButtonLoading.value = true;
  try {
    error.value = null;
    const response = await fetch('https://exzzid5w54.execute-api.eu-central-1.amazonaws.com/default/executing_suggested_values', {
      method: 'POST',
      body: JSON.stringify({
        comparison_tables: tablesData.value,
        integration: props.service.integration_name,
        user_id: userRef.value.id,
        category: category,
        feature: feature
      })
    });
    if (!response.ok) {
      throw new Error('Failed to approve all changes');
    }
    for (let i = 0; i < tablesData.value.length; i++) {
      approvedSet.value.add(i);
    }
  } catch (err) {
    console.error('Error approving all changes:', err);
    error.value = 'Failed to approve all changes. Please try again.';
  } finally {
    approveButtonLoading.value = false;
  }
}

watch(displayAll, async (newVal) => {
  isLoadingTable.value = true;
  if (newVal === false) {
    tablesData.value.forEach((tableData, index) => {
      tableData.rows.forEach((row) => {
        if (row.field !== 'name') {
          row['suggested_value'] = summaryRows.value[index][`${row.field}_suggested_value`];
        }
      })
    });
  } else if (newVal === true) {
    console.log(tablesData.value)
    buildSummaryTable();
    console.log(summaryRows.value);
  }
  isLoadingTable.value = false;
});

const onCellEditComplete = (event) => {
  let { data, newValue, field } = event;
  console.log("editing field "+ field + ", changing '" + JSON.stringify(data[field]) +"' to '" + JSON.stringify(newValue) + "'" );

  if (newValue.text.trim().length > 0) data[field].text = newValue.text;
  else event.preventDefault();
  console.log(tableData.value);
};

const getSlideContent = async () => {
  return new Promise((resolve) => {
    const listener = (event) => {
      var msg = JSON.parse(event.data);
      if (
        msg.MessageId === 'CallPythonScript-Result'
        && msg.Values.commandName.startsWith("vnd.sun.star.script:XavierActions.py$GetCurrentSlideText")
      ) {
        if (msg.Values.success === true) {
          const result = msg.Values.result.value;
          resolve(result);
        } else {
          resolve(null);
        }
      }
    };

    document.getElementById("coolframe").contentWindow.postMessage(JSON.stringify({
      "MessageId": "CallPythonScript",
      "SendTime": Date.now(),
      "ScriptFile": "XavierActions.py",
      "Function": "GetCurrentSlideText",
      "Values": {}
    }), COLLABORA_ONLINE_URL);

    window.addEventListener('message', listener);
  });
};

function close() {
  emit('closed');
}

</script>

<style scoped>
 .not-approved {
   --bulma-loading-color: white;
   background-image: linear-gradient(45deg, #E100FF 0%, #7F00FF 100%);
   color: white;
   border: none;
 }
</style>
